import { ErrorHandler, Injectable, Injector} from '@angular/core';
import { ToastrService } from '../../../../node_modules/ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {
    
   }
  handleError(error) {
     console.log('global error',error);
     const notificationService = this.injector.get(ToastrService);      
     if(error instanceof HttpErrorResponse){
        console.log('HttpErrorResponse',error.error);
         if(error.error){
             if(error.error.Type){
                notificationService.error(error.error.Message,error.error.Type,{onActivateTick:true});
             }
             else if(error.error.Message){
                notificationService.error(error.error.Message,'',{onActivateTick:true});
             }
             else if(Object.keys(error.error).length > 0) {
                let message = "<ul>";
                for(let prop in error.error){
                   let ea = error.error[prop];
                   message += "<li>";                    
                   message += `<strong>${prop}</strong>`;
                   if(ea instanceof Array){
                    message += "<ol>"; 
                       ea.forEach(e => {
                        message += `<li>${e}</li>`;
                       });
                    message += "</ol>"; 
                   }
                   message += "</li>";
                }
                message += "</ul>"; 
                notificationService.error(message,'Validation errors',{onActivateTick:true,enableHtml:true});
             }
             else if(error.statusText){
                notificationService.error(error.statusText,'',{onActivateTick:true});                 
             }
         }
     }
     else {
         throw error;
    }
     
  }
  
}